'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { SubmitButton } from '#pplx/frontend/composer-sdk/components/SubmitButton.js';
import { useComposerState } from '#pplx/frontend/composer-sdk/internal/input-state/useComposerState.js';
import { usePrimaryAction } from '#pplx/frontend/composer-sdk/internal/primary-action/usePrimaryAction.js';
import React, { useCallback, useMemo } from 'react';
function resolveButtonVariant(variant = 'primary') {
    switch (variant) {
        case 'primary':
        case 'tonal':
            return variant;
        default:
            return assertUnreachableValue(variant);
    }
}
/**
 * Renders the composer's primary button. Delegates to the arbiter: the
 * highest-priority plugin candidate whose `when` matches drives the button;
 * otherwise the built-in submit renders as the priority-0 fallback. This host
 * applies the supported variant and keeps ownership of size and rounding.
 */
export function PrimaryActionCapabilityHost({ plugins, submitLabel, submitDisabledTooltip, isSubmitDisabled, onSubmit, }) {
    const { hasDraft, status } = useComposerState();
    const isSubmitting = status === 'submitting';
    const renderDefault = useCallback(() => (_jsx(SubmitButton, { label: submitLabel, disabledTooltip: submitDisabledTooltip, disabled: isSubmitDisabled, isLoading: isSubmitting, onClick: onSubmit })), [submitLabel, submitDisabledTooltip, isSubmitDisabled, isSubmitting, onSubmit]);
    const context = useMemo(() => ({ hasDraft, status, submit: { renderDefault } }), [hasDraft, status, renderDefault]);
    const spec = usePrimaryAction(plugins, context);
    if (!spec) {
        return renderDefault();
    }
    const isDisabled = spec.isDisabled ?? false;
    return (_jsx(SubmitButton, { icon: spec.icon, label: spec.ariaLabel, variant: resolveButtonVariant(spec.variant), rounded: true, disabled: isDisabled, isLoading: spec.isLoading, tooltipSubtitle: spec.tooltip, onClick: spec.onPress }));
}
//# sourceMappingURL=PrimaryActionCapabilityHost.js.map